import FieldInput from 'common/components/form/FieldInput';
import FieldSelect from 'common/components/form/FieldSelect';
import FieldMultiSelect from 'common/components/form/FieldMultiSelect';
import FieldDate from 'common/components/form/FieldDate';
import FieldTime from 'common/components/form/FieldTime';
import FieldTextArea from 'common/components/form/FieldTextArea';
import CustomFields from 'common/components/form/CustomFields';
import Checkbox from 'common/components/form/Checkbox';
import Radio from 'common/components/form/Radio';
import Button from 'common/components/form/Button';
import Section from 'common/components/form/Section';
import { Link } from 'react-router-dom';

export default {
  FieldInput,
  FieldSelect,
  FieldMultiSelect,
  FieldDate,
  FieldTime,
  FieldTextArea,
  CustomFields,
  Checkbox,
  Radio,
  Button,
  Link,
  Section,
};



// WEBPACK FOOTER //
// src/modules/common/components/form/index.js